<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchTransportation" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.name"
                        placeholder="รายชื่อขนส่ง"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchTransportation"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <template v-if="canSaleOrdersCreate">
                        <router-link to="transportation-form">
                            <button class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon>
                                เพิ่มขนส่ง
                            </button>
                        </router-link>
                    </template>
                    &nbsp;
                    <template v-if="canSaleOrdersCreate">
                        <button class="btn btn-info my-2 my-sm-0"
                                @click="showEditTransportFee"
                                type="button">
                            <icon name="pencil-alt"></icon>
                            เพิ่ม/ลด ค่าขนส่ง
                        </button>
                    </template>
                    &nbsp;
                    <template v-if="canSaleOrdersCreate">
                        <button class="btn btn-secondary my-2 my-sm-0"
                                @click="printTransportFee"
                                type="button">
                            <icon name="print"></icon>
                            รายการส่งของ(excel)
                        </button>
                    </template>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ชื่อขนส่ง</th>
                    <th scope="col">เบอร์โทรศัพท์</th>
                    <th scope="col">ที่อยู่</th>
                    <th scope="col">ค่าขนส่งรถใหญ่</th>
                    <th scope="col">ค่าขนส่งรถบริษัท</th>
                    <th scope="col">ค่าขนส่งรถเล็ก</th>
                    <th scope="col">สายขนส่ง</th>
                    <template v-if="canSaleOrdersUpdate">
                        <th scope="col">ดูข้อมูล</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(data, index) in transportationList">
                    <td>{{ data.name }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.address }}</td>
                    <td>{{ data.big_car_cost | currency }}</td>
                    <td>{{ data.company_car_cost | currency }}</td>
                    <td>{{ data.small_car_cost | currency }}</td>
                    <td>{{ data.transport_line_name }}</td>
                    <template v-if="canSaleOrdersUpdate">
                        <td>
                            <a @click="showTransportationData(data.id)">
                                <icon name="pencil-alt">
                                </icon>
                            </a>
                            &nbsp&nbsp
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash">
                                </icon>
                            </a>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="transportationList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getTransportationPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- ---delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteTransportation"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal size="lg" hide-header hide-footer ref="edit_transport_fee">
            <edit-transport-fee-modal @submit="saveIncrementTransportFee">
            </edit-transport-fee-modal>
        </b-modal>
        <!--<pre class="alert-primary">{{transportationList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import {canSaleOrdersCreate, canSaleOrdersUpdate} from "../../../util/Permissions";
import EditTransportFeeModal from "./EditTransportFeeModal";
import {domain} from "../../../util/Constants";

export default {
    components: {
        EditTransportFeeModal,
        VuePagination
    },
    name: "transportation-list",
    data() {
        return {
            delete_item: "",
            event_submit: false
        }
    },
    created() {
        this.$store.dispatch('Transportation/setTransportShow');
        this.$store.dispatch('Transportation/clearSearch');
        this.$store.dispatch('Transportation/setTransport');
    },
    computed: {
        canSaleOrdersCreate,
        canSaleOrdersUpdate,
        ...mapState({
            transportationList: state => {
                return state.Transportation.transportationList;
            },
            dataPaginate: state => {
                return state.Transportation.dataPaginate;
            },
            search: state => {
                return state.Transportation.search;
            },
        })
    },
    methods: {
        showDeleteModal(id) {
            this.delete_item = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showTransportationData(id) {
            this.$store.dispatch('Transportation/show', id)
                .then(() => {
                    this.$router.push({
                        name: "transportation-form",
                        params: {
                            id: id
                        }
                    })
                })
        },
        deleteTransportation() {
            this.$store.dispatch("Transportation/delete", this.delete_item)
                .then(() => {
                    this.hideDeleteModal();
                    this.$store.dispatch('Transportation/setTransport');
                });
        },
        searchTransportation() {
            this.event_submit = true;
            this.$store.dispatch("Transportation/search", this.search)
        },
        getTransportationPage() {
            const page = this.dataPaginate.current_page;
            let data = {
                page: page,
                name: this.search.name
            };
            if (this.event_submit) {
                this.$store.dispatch('Transportation/search', data);
            } else {
                this.$store.dispatch('Transportation/setTransportShow', page);
            }
        },
        showEditTransportFee() {
            this.$refs.edit_transport_fee.show();
        },
        printTransportFee() {
            window.open(`${domain}/get_transportation_excel?name=${this.search.name}`)
        },
        saveIncrementTransportFee(val) {
            //action 1 = +เพื่ม
            //action 2 = +ลด
            //transport1 = พุทธมณฑล
            //transport2 = พุทธมณฑล
            if (val) {
                this.$store.dispatch("Transportation/updateTransportationFee", val).then(data => {
                    alert(data);
                    this.$store.dispatch('Transportation/setTransport');
                }).catch(err => {
                    //console.log(err);
                    alert("ไม่สามารถอัพเดตค่าขนส่งได้ เนื่องจากไม่ได้ action หรือ ไม่ได้ใส่ราคาที่ต้องการอัพเดค");
                });
            }
            this.$refs.edit_transport_fee.hide();
        }
    }
}
</script>

<style scoped>

</style>
